import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { FormGeradorPage } from '../../form-gerador/form-gerador.page';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'app-grupo-gerenciar-esporadico-add',
  templateUrl: './grupo-gerenciar-esporadico-add.page.html',
  styleUrls: ['./grupo-gerenciar-esporadico-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule
  ],
})
export class GrupoGerenciarEsporadicoAddPage implements OnInit {
  pessoa: any = {};
  visitante: any = {};
  btn_salvar: any = false;
  idReuniao: any;
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  visitantes: any = [];
  idGrupo: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public userProvider: UserProvider
  ) {
    this.idReuniao = this.navParams.get('idReuniao');
    this.idGrupo = this.navParams.get('idGrupo');
  }

  ngOnInit() { }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async selecionarPessoa() {
    const dataPessoa = { buscarGeral: true, adiciona: true, isPessoasSemGrupo: this.idGrupo, isPessoasSemGrupoReuniao: this.idReuniao };
    const modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const pessoa = (await modalPessoa.onWillDismiss());
    if (pessoa.data) {
      this.pessoa = pessoa.data.pessoa;
    }
  }

  salvar(id: any) {
    this.btn_salvar = true;
    this.grupoProvider.criarEsporadico(this.idReuniao, id).subscribe((data) => {
      this.modalCtrl.dismiss(true);
      this.btn_salvar = false;
    });
  }

  criarVisitante() {
    this.userProvider.getDados().then(async result => {
      const cadastro: any = {};
      cadastro.form = 'APP_GRU_ESPOR';
      cadastro.idPessoaTipo = 5;
      cadastro.titulo = this.translate.instant('Adicionar Esporádico');
      cadastro.idInstituicao = result.instituicao.id;

      const modalPessoa = await this.modalCtrl.create({ component: FormGeradorPage, componentProps: cadastro });
      modalPessoa.present();

      const pessoa = (await modalPessoa.onWillDismiss());

      if (pessoa.data) {
        this.pessoa = pessoa.data;
      }
    });
  }
}
